import { fileUrl } from "../lib/api";

export default function AuthImage({ path, className, alt = "photo proof" }) {
  if (!path) return null;
  return <img src={fileUrl(path)} alt={alt} className={className} data-testid="photo-proof-preview" />;
}
